import React, {useState, useLayoutEffect, useRef} from "react";
import { Tooltip } from "antd";
import "./index.less";

const lineChart = ({ blankText = '' }) => {
    const lineRef = useRef(null);
    const [showMore, setShowMore] = useState(false);

    useLayoutEffect(() => {
        if (lineRef.current.clientWidth < lineRef.current.scrollWidth) {
            setShowMore(true);
        }
        // console.log(lineRef.current.clientWidth, lineRef.current.scrollWidth, blankText,"====323232")
    }, [lineRef]);

    if(!showMore){
        return <div className="line-chart-html" ref={lineRef}>{blankText}</div>;
    }
    return (
        <Tooltip
            className={`student-form-tooltip`}
            placement="bottomRight"
            title={blankText}>
            <div className="line-chart-html">{blankText}</div>
        </Tooltip>
    );
};
export default lineChart;
